import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';

export interface MatirialList {
  Item: string;
  Category: string;
  Unit: string;
  Monday: number;
  Tuesday: number;
  Wednesday: number;
  Thursdat: number;
  Friday: number;
  Saturday: number;
  Sunday: number;

}
const ELEMENT_DATA: MatirialList[] = [
  { Item: 'Leptop', Category: 'Electronics', Unit: 'no.s', Monday: 1, Tuesday: 1, Wednesday: 1, Thursdat: 1, Friday: 1, Saturday: 1, Sunday: 1 },
  { Item: 'Leptop', Category: 'Electronics', Unit: 'no.s', Monday: 1, Tuesday: 1, Wednesday: 1, Thursdat: 1, Friday: 1, Saturday: 1, Sunday: 1 },
  { Item: 'Leptop', Category: 'Electronics', Unit: 'no.s', Monday: 1, Tuesday: 1, Wednesday: 1, Thursdat: 1, Friday: 1, Saturday: 1, Sunday: 1 },
  { Item: 'Leptop', Category: 'Electronics', Unit: 'no.s', Monday: 1, Tuesday: 1, Wednesday: 1, Thursdat: 1, Friday: 1, Saturday: 1, Sunday: 1 },
  { Item: 'Leptop', Category: 'Electronics', Unit: 'no.s', Monday: 1, Tuesday: 1, Wednesday: 1, Thursdat: 1, Friday: 1, Saturday: 1, Sunday: 1 },
  { Item: 'Leptop', Category: 'Electronics', Unit: 'no.s', Monday: 1, Tuesday: 1, Wednesday: 1, Thursdat: 1, Friday: 1, Saturday: 1, Sunday: 1 },
];

@Component({
  selector: 'app-material-usage-trend',
  templateUrl: './material-usage-trend.component.html',
  styleUrls: ['./material-usage-trend.component.scss']
})

export class MaterialUsageTrendComponent implements OnInit {
  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;
  displayedColumns: string[] = ['Item', 'Category', 'Unit', 'Monday', 'Tuesday', 'Wednesday', 'Thursdat', 'Friday', 'Saturday', 'Sunday'];
  dataSource = new MatTableDataSource<MatirialList>(ELEMENT_DATA);
  filteredOptions: Observable<string[]> | undefined;
  myControl = new FormControl();


  constructor(private router: Router) { }

  categories: any = [
    {
      name: 'Electronics'
    },
    {
      name: 'Food'
    },
    {
      name: 'Eng.'
    }
  ]

  copyItems: any = [];

  filter: any = 0;

  ngOnInit(): void {
    this.dataSource.sort = this.sort;
    // this.filteredOptions = this.myControl.valueChanges.pipe(
    //   startWith(''),
    //   map(value => this._filter(value))
    // );
  }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();

  //   return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  // }

  exportToExcel() {
    const ws: xlsx.WorkSheet =
      xlsx.utils.table_to_sheet(this.epltable.nativeElement);
    const wb: xlsx.WorkBook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
    xlsx.writeFile(wb, 'MatirialUsageTrend.xlsx');
  }



  typeFilter = (obj: any) => {
    var copyItems = this.copyItems
    var tempItem = [];
    this.filter = obj
    if (obj == 0) {
      tempItem = this.copyItems;
    }
    else if (obj == 1) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 1);
    }
    else if (obj == 2) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 2);
    }
    else if (obj == 3) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 3);
    }
    // else if (obj == 4) {
    //   tempItem = copyItems.filter((x: any) => x.TypeID == 4);
    // }
    // else if (obj == 5) {
    //   tempItem = copyItems.filter((x: any) => x.TypeID == 5);
    // }

    // this.Items = tempItem
    // this.dataSource.data = this.Items
    // //this.dataSource.filterPredicate = this.createFilter();
    // this.totalValue = 0;

    // for (let i = 0; i < this.Items.length; i++) {
    //   this.totalValue = this.totalValue + this.Items[i].ValStdCost
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }

}
